import { GetStaticProps } from "next"
import contentful from "src/util/contentful"
import ContentfulDocument from "src/common/ContentfulDocument"

function Cookies({ document }) {
  return (
    <ContentfulDocument
      document={document}
      title='Founders letter'
    />
  )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const entry = await contentful.getEntry<any>('5WpfPIuDP2YFlT8FQmjLwf')

  return {
    props: {
      document: entry.fields.body || {},
    },
  }
}

export default Cookies
